var exports = {};
var $TypeError = TypeError;
exports = function (passed, required) {
  if (passed < required) throw new $TypeError("Not enough arguments");
  return passed;
};
export default exports;